import { motion } from "framer-motion";
import { ExternalLink, BookOpen, Layers } from "lucide-react";
import { AnimatedWords } from "./HeroSection";
import { img } from "@/lib/img";

const fadeUp = { hidden: { opacity: 0, y: 25 }, visible: { opacity: 1, y: 0 } };

export default function AuthorSection() {
  return (
    <section id="author" className="py-16 sm:py-24 md:py-36 px-5 md:px-10 relative overflow-hidden bg-[#fff8f3]" data-testid="author-section">
      <img src={img("https://customer-assets.emergentagent.com/job_calma-sutras/artifacts/1t86eduj_65cc832c1d107098d228ae29_Group%2026967.avif", { w: 200 })}
        alt="" aria-hidden="true" loading="lazy" decoding="async" width="80" height="80"
        className="absolute bottom-16 right-8 md:right-20 w-14 md:w-24 opacity-40 pointer-events-none animate-float" style={{animationDelay:'3s'}} />
      <div className="max-w-[1400px] mx-auto relative">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 items-center">
          <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} transition={{ duration: 0.6 }} variants={fadeUp}>
            <span className="text-[10px] sm:text-[11px] uppercase tracking-[0.5em] text-[#96aeb4] font-semibold block mb-5">The Author</span>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-[#464646] leading-[1.1] tracking-tight mb-6">
              <AnimatedWords text="Rajesh Setty" />
            </h2>
            <p className="text-sm sm:text-base text-[#464646]/70 leading-relaxed mb-3">
              Entrepreneur, author, teacher, creator, and amateur stand-up comic. Driven by a mission to create a better world, one thoughtful project at a time.
            </p>
            <p className="text-xs sm:text-sm text-[#464646]/60 leading-relaxed mb-6">
              Decades of wisdom distilled into 52 beautifully illustrated cards and a companion book of transformative ideas.
            </p>
            <a href="https://www.rajeshsetty.com" target="_blank" rel="noopener noreferrer" data-testid="author-link"
              className="inline-flex items-center gap-1.5 text-[#96aeb4] hover:text-[#7a9099] text-xs sm:text-sm transition-colors font-medium">
              rajeshsetty.com <ExternalLink size={13} /></a>
          </motion.div>
          <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.12 }} variants={fadeUp}>
            <div className="glass rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10">
              <div className="space-y-6">
                <div className="flex items-start gap-3">
                  <div className="p-2.5 rounded-xl bg-[#96aeb4]/15"><BookOpen className="text-[#96aeb4]" size={18} /></div>
                  <div>
                    <p className="text-sm text-[#464646] font-medium">Published by</p>
                    <p className="text-xs text-[#464646]/60 mt-0.5">Revurge</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="p-2.5 rounded-xl bg-[#a6c1a8]/20"><Layers className="text-[#7a9d83]" size={18} /></div>
                  <div className="flex-1">
                    <p className="text-sm text-[#464646] font-medium">Conceptualised by</p>
                    <p className="text-xs text-[#464646]/60 mt-0.5">
                      <a href="https://www.revurge.com" target="_blank" rel="noopener noreferrer"
                        className="hover:text-[#464646] transition-colors">revurge</a>
                      <span className="mx-1.5 text-[#464646]/30">×</span>
                      <a href="https://www.become.team" target="_blank" rel="noopener noreferrer"
                        className="hover:text-[#464646] transition-colors">become</a>
                    </p>
                  </div>
                </div>
                <div className="pt-5 border-t border-[#464646]/10">
                  <p className="text-[#464646]/40 italic font-serif text-base sm:text-lg">"With gratitude and calm"</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
